export const DOCUMENT_COLLECTION_MODE = {
  EDIT: 'edit',
  VIEW: 'view',
};

export const DOCUMENT_COLLECTION_LABELS = {
  TITLE: 'DOCUMENT COLLECTION',
  ADD: '+ Add Document',
  NOT_UPLOADED: 'Not uploaded',
  PENDING: 'File selected (pending upload)',
};
